import { render, staticRenderFns } from "./VPageTitle.vue?vue&type=template&id=3bf4076e&"
import script from "./VPageTitle.vue?vue&type=script&lang=js&"
export * from "./VPageTitle.vue?vue&type=script&lang=js&"
import style0 from "./VPageTitle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports